import { render, staticRenderFns } from "./AddAuthorizationContainer.vue?vue&type=template&id=4f2d6210&scoped=true"
import script from "./AddAuthorizationContainer.vue?vue&type=script&lang=js"
export * from "./AddAuthorizationContainer.vue?vue&type=script&lang=js"
import style0 from "./AddAuthorizationContainer.vue?vue&type=style&index=0&id=4f2d6210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2d6210",
  null
  
)

export default component.exports